<mat-card id="portal">
  <mat-card-header>
    <h5>Account Switcher</h5>
  </mat-card-header>
  <mat-card-content>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <mat-form-field class="w-100">
            <mat-label>Search</mat-label>
            <input matInput type="text" [(ngModel)]="dataSource.search" (ngModelChange)="onSearch()">
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>
      </div>

      <div class="row" *ngIf="(dataSource.loading | async); else showListData;">
        <div class="col-12">
          Loading accounts. Please wait...
        </div>
      </div>

      <ng-template #showListData>
        <div class="row scroll-content">
          <div class="col-sm-12" [ngClass]="{'col-md-6': getVisibleAccounts().length > 1 }" *ngFor="let record of getVisibleAccounts()">
            <div class="p-2">
              <!--
                Bound to the stored name directly. This used to call getDisplayAccountName(), which
                substituted "My Account" for the user's own personal account, but that account is now
                excluded from the list altogether so the substitution had become unreachable. The label
                still exists where it is needed, on the active account in the top navigation
                (TopNavComponent.getDisplayAccountName()).
              -->
              <a href="#" (click)="onSwitchAccount(record.id); $event.preventDefault();">{{ record.name }}</a>
            </div>
          </div>
          <div class="col-12" *ngIf="getVisibleAccounts().length === 0">
            <div class="p-2 text-muted">No other accounts to switch to.</div>
          </div>
        </div>
      </ng-template>
    </div>
  </mat-card-content>
</mat-card>
